import React, { useRef, useState, useEffect } from 'react'
import { useAuthDataContext } from '../../../../../_providers/Auth'
import Api from '../../../../../_helpers/Api'
import editIcon from '../../../../../assets/img/icons/edit-yellow.png'
import Modal from './modals/Payments'
import Skeleton from 'react-loading-skeleton'
import { trans } from '../../../../../_providers/Translation'

const BANK_FIELDS = [
    { name: 'bank_name', label: () => trans('labels.bank') },
    { name: 'bank_iban', label: () => 'IBAN' },
    { name: 'bank_swift', label: () => 'SWIFT' },
    { name: 'bank_sort_code', label: () => 'Sort Code' },
    { name: 'bank_account_number', label: () => 'Account number' },
]

// Accepts both the `bankSettings` collection and the legacy flat bank_* columns,
// with the default account always listed first
const extractBanks = data => {
    if (Array.isArray(data?.bankSettings) && data.bankSettings.length) {
        return data.bankSettings
            .slice()
            .sort((a, b) => (b.is_default ? 1 : 0) - (a.is_default ? 1 : 0))
    }

    return [BANK_FIELDS.reduce((acc, field) => ({ ...acc, [field.name]: data?.[field.name] }), { is_default: 1 })]
}

function Payments(props) {

    const auth = useAuthDataContext()

    const modalRef = useRef(null)

    const [state, setState] = useState({
        loading: true,
        data: [],
        update: false,
    })

    useEffect(() => {
        loadSettings()
    }, [state.update])

    const loadSettings = () => {
        Api.get('partners/settings/all?id=' + auth.user().partner_id)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    loading: false,
                    data: res.data
                }))
            }).catch(err => {
                setState(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    const handleUpdate = () => {
        setState(prev => ({
            ...prev,
            update: new Date().getTime()
        }))
    }

    const showModal = () => {
        let modal = modalRef.current

        modal.show(state.data)

        modal.onSave(() => {
            handleUpdate()

            if (typeof props.handleRefresh === 'function') {
                props.handleRefresh()
            }
        })
    }

    const statusDot = active => (
        <span
            style={{
                display: 'inline-block',
                width: 10,
                height: 10,
                borderRadius: '50%',
                marginRight: 8,
                verticalAlign: 'middle',
                backgroundColor: active ? '#3A61FF' : '#A3AED0'
            }}
        />
    )

    return (
        <div style={{ width: '100%' }}>
            <div className="head">
                <h3
                    style={{
                        marginBottom: 0
                    }}
                >{trans('headings.paymentsSettings')}</h3>
                <button className='button button-small button-edit' onClick={showModal}>
                    {trans('buttons.editAction')}
                </button>
            </div>
            <hr />
            {state.loading
                ?
                <Skeleton height={35} count={10} />
                :
                <>
                    <Modal
                        ref={modalRef}
                    />

                    <div className="table-scroller">
                        <table className="settings">
                            <tbody>
                                <tr>
                                    <td colSpan={3}>
                                        <b>{statusDot(state.data.is_bank_active)}{trans('labels.bankData')}</b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        {extractBanks(state.data).map((bank, index) => (
                            <React.Fragment key={bank.id || index}>
                                {index > 0 ? <hr /> : <></>}
                                <table className="settings">
                                    <tbody>
                                        <tr>
                                            <td colSpan={3}>
                                                <b>
                                                    {`${trans('labels.bankAccount')} ${index + 1}`}
                                                    {bank.is_default ? ` (${trans('labels.default')})` : ''}
                                                </b>
                                            </td>
                                        </tr>
                                        {BANK_FIELDS.map(field => (
                                            <tr key={field.name}>
                                                <td>
                                                    <b>{field.label()}</b>
                                                </td>
                                                <td>
                                                    {bank[field.name] ? bank[field.name] : trans('labels.notSpecified')}
                                                </td>
                                                <td>

                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </React.Fragment>
                        ))}
                        <hr />
                        <table className="settings">
                            <tbody>
                                <tr>
                                    <td colSpan={3}>
                                        <b>{statusDot(state.data.is_epay_active)}ePay</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <b>ePay Client ID</b>
                                    </td>
                                    <td>
                                        {state.data.epay_client_id ? state.data.epay_client_id : trans('labels.notSpecified')}
                                    </td>
                                    <td>

                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <b>ePay Secret</b>
                                    </td>
                                    <td>
                                        {state.data.epay_client_secret ? state.data.epay_client_secret : trans('labels.notSpecified')}
                                    </td>
                                    <td>

                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <b>{trans('random.epay_url')}</b>
                                    </td>
                                    <td>
                                        {props.partner.epay_receive_url}
                                    </td>
                                    <td>

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <hr />
                        <table className="settings">
                            <tbody>
                                <tr>
                                    <td colSpan={3}>
                                        <b>{statusDot(state.data.is_paypal_active)}PayPal</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <b>PayPal Client ID</b>
                                    </td>
                                    <td>
                                        {state.data.paypal_client_id ? state.data.paypal_client_id : trans('labels.notSpecified')}
                                    </td>
                                    <td>

                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <b>PayPal Secret</b>
                                    </td>
                                    <td>
                                        {state.data.paypal_client_secret ? state.data.paypal_client_secret : trans('labels.notSpecified')}
                                    </td>
                                    <td>

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <hr />
                        <table className="settings">
                            <tbody>
                                <tr>
                                    <td colSpan={3}>
                                        <b>{statusDot(state.data.is_stripe_active)}Stripe</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <b>Stripe Key</b>
                                    </td>
                                    <td>
                                        {state.data.stripe_key ? state.data.stripe_key : trans('labels.notSpecified')}
                                    </td>
                                    <td>

                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <b>Stripe Secret</b>
                                    </td>
                                    <td>
                                        {state.data.stripe_secret ? state.data.stripe_secret : trans('labels.notSpecified')}
                                    </td>
                                    <td>

                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <b>Stripe Webhook Secret</b>
                                    </td>
                                    <td>
                                        {state.data.stripe_webhook_secret ? state.data.stripe_webhook_secret : trans('labels.notSpecified')}
                                    </td>
                                    <td>

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <hr />
                        <table className="settings">
                            <tbody>
                                <tr>
                                    <td>
                                        <b>{statusDot(state.data.is_card_active)}{trans('labels.card')}</b>
                                    </td>
                                    <td>

                                    </td>
                                    <td>

                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <b>{statusDot(state.data.is_in_cash_active)}{trans('labels.inCash')}</b>
                                    </td>
                                    <td>

                                    </td>
                                    <td>

                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <b>{statusDot(state.data.is_paypal_credit_debit_card_active)}{trans('labels.paypalCreditDebitCard')}</b>
                                    </td>
                                    <td>

                                    </td>
                                    <td>

                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <b>{statusDot(state.data.is_no_payment_needed_active)}{trans('labels.noPaymentNeeded')}</b>
                                    </td>
                                    <td>

                                    </td>
                                    <td>

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            }
        </div>
    )

}

export default Payments